module.exports = {
    /**
     * A few helper methods for making HTTP requests and doing common form actions.
     */
    post: function (uri, form) {
        return App.sendForm('post', uri, form);
    },


    put: function (uri, form) {
        return App.sendForm('put', uri, form);
    },


    delete: function (uri, form) {
        return App.sendForm('delete', uri, form);
    },


    /**
     * Send the form to the back-end server. Perform common form tasks.
     *
     * This function will automatically clear old errors, update "busy" status, etc.
     */
    sendForm: function (method, uri, form) {
        return new Promise(function(resolve, reject) {
            form.startProcessing();

            Vue.http[method](uri, form)
                .success(function(response) {
                    form.finishProcessing();

                    resolve(response);
                })
                .error(function(errors) {
                    console.log("HTTP ERROR:", errors);

                    if (errors && typeof errors === "object") {
                        form.errors.set(errors);
                    } else {
                        form.errors.set({
                            message: "Something went wrong. Please try again."
                        });
                    }

                    form.busy = false;
                    reject(errors);
                });
        });
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/forms/http.js